module.exports = __webpack_public_path__ + "static/media/Volcano_Badge.bf2de797.png";